import React, { useState } from 'react';
import axios from 'axios';

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // const response = await axios.post('http://localhost:4000/api/auth/login', {
      //   username,
      //   password
      // });
      const response = await axios.post('https://nayoolwin-backend-api.vercel.app/api/auth/login', {
        username,
        password
      });

      if (response.data.success && response.data.token) {
        // Store token for API calls
        localStorage.setItem('authToken', response.data.token);
        onLogin({
          username: response.data.user.username,
          loginTime: new Date().toLocaleString()
        });
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
      setPassword('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Admin Dashboard</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              placeholder="Enter username"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              placeholder="Enter password"
            />
          </div>

          <button
            type="submit"
            className={`login-btn ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>

          {error && <div className="error-message">{error}</div>}
        </form>

        <div style={{ marginTop: '20px', padding: '15px', background: '#f0f0f0', borderRadius: '5px', fontSize: '12px', color: '#666' }}>
          <strong>Demo Credentials:</strong><br />
          Username: nayoolwin<br />
          Password: password123
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
